import { render, staticRenderFns } from "./MoreQuestions.vue?vue&type=template&id=091006e8&scoped=true&"
import script from "./MoreQuestions.vue?vue&type=script&lang=js&"
export * from "./MoreQuestions.vue?vue&type=script&lang=js&"
import style0 from "./MoreQuestions.vue?vue&type=style&index=0&id=091006e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091006e8",
  null
  
)

export default component.exports